import React from 'react';
import { List, Markup, LazyImage } from '@landing/ui';
import { Button, Notice } from 'components/UI';

import * as styles from './SectionContent.module.scss';

export default function SectionContent({
  img,
  name,
  specialisations,
  requirements,
  plus,
  notification,
  button,
  linkText,
}) {
  return (
    <div className={styles.section}>
      <div className={styles.imgWrapper}>
        <LazyImage
          src={img}
          width={516}
          height={457}
          quality={100}
          alt={name}
          style={{
            maxWidth: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </div>
      <div className={styles.infoWrapper}>
        {specialisations && (
          <>
            <p className={styles.title}>Specialization options:</p>
            <p className={styles.subtitle}>{specialisations}</p>
          </>
        )}
        {requirements && (
          <>
            <p className={styles.title}>Requirements for candidates:</p>
            <List items={requirements} className={styles.list} />
          </>
        )}
        {plus && (
          <>
            <p className={styles.title}>Will be a plus:</p>
            <List items={plus} className={styles.list} />
          </>
        )}
        {notification && <Notice className={styles.notice}>{notification}</Notice>}
        {button && (
          <Button
            tag="a"
            href={button.link}
            fullWidthMobile
            className={styles.button}
            target="_self"
          >
            {button.text}
          </Button>
        )}
        {linkText && (
          <Markup tag="p" className={styles.linkText}>
            {linkText}
          </Markup>
        )}
      </div>
    </div>
  );
}
